export const FETCH_STATUS = {
    NOT_STARTED: 'NOT_STARTED',
    REQUESTED: 'REQUESTED',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
}

export const CALL_API = Symbol('CALL_API')

export default {
    CALL_API,
    FETCH_STATUS,
}
